module.exports = __webpack_public_path__ + "static/img/qr-code4.845f2c6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr-code4.jpeg
// module id = MuTb
// module chunks = 0